<template>
  <v-app class="my-application">
    <Appbar></Appbar>
    <v-main>
      <PageLoader v-if="loader"></PageLoader>
      <router-view :key="$route.fullPath" :style="main"></router-view>
    </v-main>
    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      class="mb-16"
      style="white-space: pre-line"
    >
      <span v-html="snackbar.text"> </span>
      <template v-slot:action="{ attrs }">
        <v-btn dense text icon x-small v-bind="attrs" @click="closeSnackbar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>


<script>
import PageLoader from "./components/PageLoader.vue";
import Appbar from "./components/Appbar.vue";
import { Device } from "@capacitor/device";
import { mapActions, mapMutations, mapState } from "vuex";
import { BleClient } from "@capacitor-community/bluetooth-le";
import { SafeArea } from "capacitor-plugin-safe-area";
import axios from "axios";
export default {
  components: {
    Appbar,
    PageLoader,
  },

  async created() {
    try {
      const info = await Device.getInfo();
      if (info.platform == "ios")
        SafeArea.getSafeAreaInsets().then(({ insets }) => {
          this.setInsets(insets);
        });

      if (info.platform !== "web") {
        const delegate = new window.cordova.plugins.locationManager.Delegate();
        window.cordova.plugins.locationManager.setDelegate(delegate);
      }

      if (info.platform !== "web") {
        if (info.platform === "android") {
          await BleClient.initialize();
          await BleClient.enable();
        }
      }

      this.loader = false;

      if (this.$store.state.base.mobileLang == null) {
        const code = await Device.getLanguageCode();
        console.log("CODE", this.languages);
        const found = this.languages.find(
          (el) => el.code == code.value.split("-")[0]
        );
        console.log("found", found, "code", code);
        if (found == undefined) {
          this.setMobileLang("en");
          this.$i18n.locale = "en";
          await this.getCategories();
        } else {
          this.setMobileLang(code.value.split("-")[0]);
          this.$i18n.locale = code.value.split("-")[0];
          await this.getCategories();
        }
      } else {
        axios.defaults.headers.common[
          "Accept-Language"
        ] = `${this.mobileLang.code}`;
        this.$i18n.locale = this.mobileLang.code;
        await this.getCategories();
      }
      // App.addListener("backButton", this.$router.go(-1));
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      batteryLevel: null,
      eventLocation: null,
      location: null,
      loader: true,
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
      languages: (state) => state.base.languages,
      insets: (state) => state.base.insets,
    }),

    snackbar: {
      get() {
        return this.$store.state.base.snackbar;
      },
      set(value) {
        this.toggleSnackbar(value);
      },
    },

    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },
  },

  methods: {
    ...mapMutations([
      "setMobileLang",
      "getLocation",
      "setInsets",
      "toggleSnackbar",
    ]),
    ...mapActions(["getCategories"]),

    closeSnackbar() {
      this.toggleSnackbar({
        open: false,
        text: null,
        color: null,
      });
    },
  },
};
</script>


<style lang="scss">
//======VUETIFY OVERRIDES========

.v-main__wrap {
  display: flex;
}

.v-toolbar__content {
  padding: 10px !important;
  justify-content: space-between !important;
  flex-grow: 1;
}

.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 25px !important;
} //search input height

.v-icon.notranslate.mdi.mdi-circle-outline.theme--light {
  color: white !important;
} //checkbox color when unchecked

//======GLOBAL STYLES=======
.component-wrapper {
  flex-grow: 1;
  // padding-top: 10px;
}

@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap");
$font-family: "Open Sans", sans-serif;
.my-application {
  *:not(.v-icon),
  *:not(.v-icon):before,
  *:not(.v-icon):after {
    font-family: $font-family !important;
  }

  //transition styles
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
